module.exports = __webpack_public_path__ + "static/maintenance-4b442fd00d251c5bd1500cbfb013f728.svg";